export const LOGO_THEME_BLACK_COLOR = "black-color-theme";
export const LOGO_THEME_BLACK = "black-theme";
export const LOGO_THEME_LIGHT_COLOR = "light-color-theme";
export const LOGO_THEME_LIGHT = "light-theme";
